import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { MobileFilters } from "./MobileFilters";

export function SearchInput() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [query, setQuery] = useState("");
    const [specialization, setSpecialization] = useState("");
    const debounceRef = useRef(null);

    // on mount: read params and populate state
    useEffect(() => {
        const q = searchParams.get("q") || "";
        const spec = searchParams.get("specialization") || "";
        setQuery(q);
        setSpecialization(spec);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // run once on mount

    // update URL params when specialization changes (immediate)
    useEffect(() => {
        const params = new URLSearchParams(searchParams.toString());

        if (specialization) {
            params.set("specialization", specialization);
        } else {
            params.delete("specialization");
        }

        // Keep 'q' as-is in URL (so we don't lose it). If you want to overwrite with current query, set it here.
        if (query) {
            params.set("q", query);
        } else {
            params.delete("q");
        }

        setSearchParams(params, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specialization]);

    // update URL params for query with debounce
    useEffect(() => {
        // clear previous timer
        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            const params = new URLSearchParams(searchParams.toString());
            if (query) params.set("q", query);
            else params.delete("q");
            setSearchParams(params, { replace: true });
        }, 300); // 300ms debounce

        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    return (
        <div className="flex items-center space-x-4 mb-8">
            <div className="relative flex-grow">
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search for Specialization"
                    className="w-full py-3 pl-14 pr-4 bg-gradient-radial bg-black rounded-xl rounded-tr-md focus:outline-none focus:ring-1 focus:ring-gray-500 text-white"
                />
                <div className="h-7 w-8 absolute flex flex-col items-center left-3 top-1/2 transform -translate-y-1/2 border-r border-gray-600 pr-2 py-1">
                    <img className="h-5 w-5" src="/assets/gym-trainer-list/search.png" alt="search" />
                </div>
            </div>

            {/* Mobile Filter Toggle */}
            <MobileFilters />

            {/* Specialization Dropdown (Desktop) */}
            <select
                value={specialization}
                onChange={(e) => setSpecialization(e.target.value)}
                className="hidden md:block py-3 px-4 bg-gradient-radial bg-black rounded-xl rounded-tr-md text-white appearance-none focus:outline-none focus:ring-1 focus:ring-gray-500"
            >
                <option value="">Specialization</option>
                <option value="Strength Training">Strength Training</option>
                <option value="Zumba">Zumba</option>
            </select>
        </div>
    );
}
